import { useCxt } from "./StructureProvider";
import PropTypes from "prop-types";
import styles from "./Table.module.css";
import classNames from "classnames";
import teamList from "./teamList.json";
import produce from "immer";
import global_styles from "./global.module.css";


function Table({ stage, work, callBack }) {
	const {leagueStructure, updateLeagueStructure} = useCxt();
	let structure = leagueStructure;
	console.log("Table");
	console.log(leagueStructure);
	
	function strToTeamN( info ) {
		const stageM = info[0] * 1;
		const workM = info[1] * 1;
		const gameM = info[2] * 1;
		const isWin = info[3] === 'W';
		
		const game = leagueStructure[stageM].works[workM].games[gameM];
		if(game.score === "0:0") return -1;

		return (((game.score[0] * 1) > (game.score[2] * 1)) === isWin) ? game.team1 : game.team2;	
	}
	
	function teamAndScore( stageN, workN, gameN, teamN ) {
		console.log(stageN, workN, gameN, teamN);
		const teamInfo = leagueStructure[stageN].works[workN].games[gameN][teamN];
		
		function getTeam( info ) {
			const team = strToTeamN(info);
			if(team === -1) return "TBD";

			structure = produce(structure, (input) => {
				input[stageN].works[workN].games[gameN][teamN] = team;
			});
			
			return teamList[team].team;
		};
		
		return ([
			<div className={styles.team_name} key={["team", stageN, workN, gameN, teamN]}>{(typeof(teamInfo) === 'number') ? teamList[teamInfo].team : getTeam(teamInfo)}</div>,
			<div className={styles.score} key={["score", stageN, workN, gameN, teamN]}>{leagueStructure[stageN].works[workN].games[gameN].score[teamN === "team1" ? 0 : 2]}</div>
		]);
	}
	
	function teamAndQualification( info, qualification ) {
		const teamN = strToTeamN(info);
		const team = teamN !== -1 ? teamList[teamN].team : "TBD";
		return ([
			<div className={styles.team_name} key={["team", info, qualification]}>{team}</div>,
			<div className={styles.score} key={["qualification", info, qualification]}>{teamN !== -1 ? qualification : ""}</div>
		]);
	}
	
	function teamOnly( stageN, workN, gameN, teamN ) {
		console.log(stageN, workN, gameN, teamN);
		const teamInfo = leagueStructure[stageN].works[workN].games[gameN][teamN];
		
		function getTeam( info ) {
			const team = strToTeamN(info);
			console.log("[getTeam] " + team);
			if(team === -1) return "TBD";

			structure = produce(structure, (input) => {
				input[stageN].works[workN].games[gameN][teamN] = team;
			});
			
			return teamList[team].team;
		};
		return <div className={classNames([styles.team_name, styles.team_only])} key={["team", stageN, workN, gameN, teamN]}>{(typeof(teamInfo) === 'number') ? teamList[teamInfo].team : getTeam(teamInfo)}</div>;
	}
	
	function tableWQS() {		
		return (
			<div className={styles.table} key="tableWQS">
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(0, 0, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(0, 0, 0, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.horizontal, styles.line])}></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("000W", "Q")}</div>
			</div>
		);
	}	
	
	function tablePlayIn( group ) {
		const groupN = group === "A" ? 0 : 1;
		return (
			<div className={styles.table} key={["tablePlayIn",  group]}>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, groupN, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, groupN, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, groupN, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, groupN, 1, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.up_right, styles.line])}></div>
				<div className={classNames([styles.left_down, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.up_left, styles.line])}></div>
				<div className={classNames([styles.right_down, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.left_down, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.left_down, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, 2 + groupN, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, 2 + groupN, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, 2 + groupN, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, 2 + groupN, 1, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.horizontal, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.left_down, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.horizontal, styles.line])} ></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("1" + (2+groupN) + "0W", "Q")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, 4, groupN, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(1, 4, groupN, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.horizontal, styles.line])} ></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("14" + groupN + "W", "Q")}</div>
			</div>
		);
	}

	function tableQualifiers( ) {
		return (
			<div className={styles.table} key={"tableQualifiers"}>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(2, 0, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(2, 0, 0, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.horizontal, styles.line])}></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("200W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("201W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.horizontal, styles.line])}></div>
				
				<div className={classNames([styles.team, styles.bracket, styles.newline])}>{teamAndScore(2, 0, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(2, 0, 1, "team2")}</div>
			</div>
		);
	}
	
	function tableSwiss1S() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss" style={{gridTemplateColumns: "200px 20px 200px"}}>
				<div className={classNames([styles.team, styles.bracket, styles.newline])}>{teamOnly(3, 1, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 3, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} ></div>
				
				<div className={classNames([styles.team, styles.bracket, styles.newline])}>{teamOnly(3, 1, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 5, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 6, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 6, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 7, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 1, 7, "team2")}</div>
			</div>
		);
	}
	
	function tableSwiss1R() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss" style={{gridTemplateColumns: "200px 20px 200px"}}>
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 3, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} ></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 5, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 6, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 6, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 7, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 1, 7, "team2")}</div>
			</div>
		);
	}

	function tableSwiss2S() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>1W-0L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 3, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} ></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>0W-1L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 5, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 6, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 6, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 7, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 3, 7, "team2")}</div>
			</div>
		);
	}
	
	function tableSwiss2R() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>1W-0L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 3, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>0W-1L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 5, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 6, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 6, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 7, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 3, 7, "team2")}</div>
			</div>
		);
	}

	function tableSwiss3S() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>2W-0L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 1, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>				
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>1W-1L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 3, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 5, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>0W-2L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 6, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 6, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 7, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 5, 7, "team2")}</div>
			</div>
		);
	}
	
	function tableSwiss3R() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>2W-0L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 1, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>				
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>1W-1L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 3, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 5, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>0W-2L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 6, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 6, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 7, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 5, 7, "team2")}</div>
			</div>
		);
	}

	function tableSwiss4S() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3W</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("350W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("351W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line1"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>2W-1L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 2, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line2"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>1W-2L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 3, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 7, 5, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line3"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("356L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("357L", "F")}</div>
			</div>
		);
	}

	function tableSwiss4R() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3W</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("350W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("351W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line1"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>2W-1L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 2, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line2"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>1W-2L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 3, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 4, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 4, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 5, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 7, 5, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line3"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("356L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("357L", "F")}</div>
			</div>
		);
	}

	function tableSwiss5S() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3W</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("350W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("351W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("370W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("371W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("372W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line1"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>2W-2L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 9, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 9, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 9, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 9, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 9, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamOnly(3, 9, 2, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line2"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("356L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("357L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("373L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("374L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("375L", "F")}</div>
			</div>
		);
	}

	function tableSwiss5R() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3W</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("350W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("351W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("370W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("371W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("372W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line1"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>2W-2L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 9, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 9, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 9, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 9, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 9, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(3, 9, 2, "team2")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line2"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("356L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("357L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("373L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("374L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("375L", "F")}</div>
			</div>
		);
	}

	function tableSwiss6() {
		return (
			<div className={classNames([styles.table, styles.swiss_table, global_styles.main_container])} key="tableSwiss">
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3W</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("350W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("351W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("370W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("371W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("372W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("390W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("391W", "Q")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("392W", "Q")}</div>
				
				<div className={classNames([styles.blank, styles.line, styles.newline])} key="line1"></div>
				
				<div className={classNames([styles.blank, styles.bracket, styles.newline])}><h3>3L</h3></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("356L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("357L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("373L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("374L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("375L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("390L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("391L", "F")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("392L", "F")}</div>
			</div>
		);
	}
	
	function tablePlayOff() {
		return (
			<div className={classNames([styles.table, styles.tournament_table])} key={"tablePlayOff"}>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 1, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 2, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 2, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 3, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 1, 3, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.up_right, styles.line])}></div>
				<div className={classNames([styles.left_down, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.up_left, styles.line])}></div>
				<div className={classNames([styles.right_down, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.up_right, styles.line])} ></div>
				<div className={classNames([styles.left_down, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.up_left, styles.line])} ></div>
				<div className={classNames([styles.right_down, styles.line])} ></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 2, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 2, 0, "team2")}</div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 2, 1, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 2, 1, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.up_right, styles.line])}></div>
				<div className={classNames([styles.vertical, styles.line])}></div>
				<div className={classNames([styles.vertical, styles.line])}></div>
				<div className={classNames([styles.vertical, styles.line])}></div>
				<div className={classNames([styles.left_down, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.up_left, styles.line])} ></div>
				<div className={classNames([styles.vertical, styles.line])} ></div>
				<div className={classNames([styles.vertical, styles.line])} ></div>
				<div className={classNames([styles.vertical, styles.line])} ></div>
				<div className={classNames([styles.right_down, styles.line])} ></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 3, 0, "team1")}</div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndScore(4, 3, 0, "team2")}</div>

				<div className={classNames([styles.blank, styles.line, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])}></div>
				<div className={classNames([styles.blank, styles.line])} ></div>
				<div className={classNames([styles.horizontal, styles.line])} ></div>

				<div className={classNames([styles.blank, styles.bracket, styles.newline])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])}></div>
				<div className={classNames([styles.blank, styles.bracket])} ></div>
				<div className={classNames([styles.team, styles.bracket])}>{teamAndQualification("430W", "W")}</div>
			</div>);
	}
	
	function tableCallBack() {
		updateLeagueStructure(structure);
		callBack();
	}
	
	return(
		<>
			<div className={global_styles.main_container}>
				{ 
					stage === 0 ?
					<>
						<h3>Worlds Qualifying Series</h3>
						{tableWQS()}
					</> :
					stage === 1 ?
					<>
						<h3>Play-In Group Stage</h3>
						{tablePlayIn("A")}
						{tablePlayIn("B")}
					</> :
					stage === 2 ?
					<>
						<h3>Play-In Qualifiers</h3>
						{tableQualifiers()}
					</> :
					stage === 3 ?
					(
						work === 1 ?
						<>
								<h3>Swiss Stage Round1 Match-Up</h3>
								{tableSwiss1S()}
						</> :
						work === 2 ?
						<>
								<h3>Swiss Stage Round1 Results</h3>
								{tableSwiss1R()}
						</>	:
						work === 3 ?
						<>
								<h3>Swiss Stage Round2 Match-Up</h3>
								{tableSwiss2S()}
						</>	:
						work === 4 ?
						<>
								<h3>Swiss Stage Round2 Results</h3>
								{tableSwiss2R()}
						</>	:
						work === 5 ?
						<>
								<h3>Swiss Stage Round3 Match-Up</h3>
								{tableSwiss3S()}
						</>	:
						work === 6 ?
						<>
								<h3>Swiss Stage Round3 Results</h3>
								{tableSwiss3R()}
						</>	:
						work === 7 ?
						<>
								<h3>Swiss Stage Round4 Match-Up</h3>
								{tableSwiss4S()}
						</>	:
						work === 8 ?
						<>
								<h3>Swiss Stage Round4 Results</h3>
								{tableSwiss4R()}
						</>	:
						work === 9 ?
						<>
								<h3>Swiss Stage Round5 Match-Up</h3>
								{tableSwiss5S()}
						</>	:
						work === 10 ?
						<>
								<h3>Swiss Stage Round5 Results</h3>
								{tableSwiss5R()}
						</>	:
						<>
								<h3>Swiss Stage Result</h3>
								{tableSwiss6()}
						</>
					):
					(
						work === 0 ?
						<>
							<h3>Swiss Stage Result</h3>
							{tableSwiss6()}
						</>:
						<>
							<h3>KnockOut Stage Table</h3>
							{tablePlayOff()}
						</>
					)
				}
			</div>
			{ strToTeamN("430W") === -1 ?
				<div className={global_styles.button_container}>
					<button onClick={tableCallBack}>
						click!
					</button>
				</div> : null
			}
		</>
	);
}

Table.propTypes = {
	stage: PropTypes.number,
	work: PropTypes.number,
	callBack: PropTypes.func,
}

export default Table;